/**
 *
 */
export default {
    /**
     *
     */
    initialFilterValues() {
        this.refresh()
    },

    /**
     *
     */
    paramFilter() {
        this.refresh()
    },

    /**
     * { function_description }
     */
    'order.index'() {
        this.refresh()
    },

    /**
     *
     */
    'order.desc'() {
        this.refresh()
    },

    /**
     *
     */
    'pagination.current'(next, prev) {
        if (next !== prev) this.refresh()
    },

    /**
     *
     */
    'pagination.length'(next, prev) {
        if (next !== prev) this.refresh()
    },

    /**
     *
     */
    'pagination.limit'(next, prev) {
        if (next !== prev) this.refresh()
    },

    /**
     *
     */
    selected() {
        // verify type of selection
        if (this.selectedOne && this.selected.length > 1) {
            this.selected = this.selected.slice(-1)
        }

        // always emit selected
        this.$emit('selected', { selected: this.selected })
    },

    /**
     * @description
     */
    service() {
        this.refresh()
    },

    /**
     *
     */
    'toolbar.search': function() {
        this.refresh()
    },

    /**
     *
     */
    value() {
        this.refresh()
    },

    /**
     *
     */
    mapper() {
        this.refresh()
    },

    /**
     *
     */
    busy(val) {
        this.$emit('busy', val)
    },

    /**
     *
     */
    initialFilterValues: {
        handler(val) {
            //this.filter =
            this.submitFilter(val)
        },
        //immediate: true,
    },
}
